'use strict';

import { BaseElement } from '../interfaces/BaseElement';
import nipplejs from 'nipplejs';
import { assignDeep, isDesktop, isWeb, projectMode, threeJsVariables } from '../../settings';
import { Vector2 } from 'three';
import { autoRotateTimerAction } from './orbitControls';


export class Joystick {
	static manager = null;
	
	constructor () {
		this.params = assignDeep({desktop: isDesktop},config.features.joystick);
		this.controls = threeJsVariables.orbitControls;
		this.panStart = new Vector2();
		this.panDelta = new Vector2();
		this.panEnd = new Vector2();
		this.direction = new Vector2();
		this.animation = null;
	}
	
	create(parent) {
		if (projectMode.LiteMode.isActive()) return;
		if ((isWeb && !this.params.web) || (isDesktop && !this.params.desktop)) return;
		
		this.container = new BaseElement()
			.addClass('joystick')
			.appendTo(parent)
			.DOMElement;
		
		const controller = new BaseElement()
			.addClass('joystick__controller')
			.appendTo(this.container)
			.DOMElement;
		
		const options = {
			zone: controller,
			size: 100,
			mode: 'static',
			restJoystick: true,
			restOpacity: 1,
			shape: 'circle',
			position: { top: '60px', left: '60px' }
		};
		
		if (!Joystick.manager) {
			Joystick.manager = nipplejs.create(options);
		}
		
		const joystick = Joystick.manager['0'];
		joystick.on('start',this.start.bind(this));
		joystick.on('move',this.move.bind(this));
		joystick.on('end',this.end.bind(this));
	}
	
	start(evt,data) {
		this.panStart.set(data.position.x,data.position.y).negate();
		this.panEnd.copy(this.panStart);
		this.pan();
		autoRotateTimerAction('update');
	}
	
	move(evt,data) {
		this.direction.set(data.vector.x * -1,data.vector.y).multiplyScalar(data.force);
	}
	
	end() {
		cancelAnimationFrame(this.animation);
		this.animation = null;
		autoRotateTimerAction('update');
	}
	
	pan() {
		this.panEnd.add(this.direction);
		this.panDelta.subVectors( this.panEnd, this.panStart ).multiplyScalar( this.controls.panSpeed );
		this.controls.panCameraDelta(this.panDelta.x,this.panDelta.y);
		this.panStart.copy(this.panEnd);
		this.animation = requestAnimationFrame(this.pan.bind(this));
	}
	
	static updatePosition() {
		if (Joystick.manager) {
			const bounds = Joystick.manager.options.zone.getBoundingClientRect();
			const joystick = Joystick.manager['0'];
			joystick.position.x = bounds.left + 60;
			joystick.position.y = bounds.top + 60;
		}
	}
	
}
